(() => {
  "use strict";

  function starData(rating, max) {
    const whole = Math.floor(rating);
    const frac = rating - whole;
    let decimal = 0;
    if (frac >= 0.3 && frac <= 0.7) decimal = 0.5;
    else if (frac > 0.7) decimal = 1;
    return { whole, max, decimal };
  }

  function applyStars(el, rating, max) {
    const { whole, decimal } = starData(rating, max);
    el.style.setProperty("--rating", String(whole));
    el.style.setProperty("--rating-max", String(max));
    el.style.setProperty("--rating-decimal", String(decimal));
    el.classList.add("rating-star");
    el.setAttribute("aria-label", `${rating} / ${max}`);
  }

  function avatarNode(review) {
    if (review.authorPhotoUrl) {
      const img = document.createElement("img");
      img.className = "google-reviews__avatar";
      img.src = review.authorPhotoUrl;
      img.alt = "";
      img.loading = "lazy";
      img.width = 44;
      img.height = 44;
      return img;
    }
    const div = document.createElement("div");
    div.className = "google-reviews__avatar google-reviews__avatar--initial";
    div.textContent = (review.authorName || "?").trim().charAt(0).toUpperCase();
    return div;
  }

  function buildSlide(review, sectionId, index) {
    const li = document.createElement("li");
    li.id = `Slide-GoogleReviews-${sectionId}-${index}`;
    li.className = "google-reviews__list-item grid__item slider__slide";

    const card = document.createElement("div");
    card.className = "google-reviews__card";

    const header = document.createElement("div");
    header.className = "google-reviews__card-header";
    header.appendChild(avatarNode(review));

    const author = document.createElement("div");
    author.className = "google-reviews__author";
    const name = document.createElement("p");
    name.className = "google-reviews__author-name";
    name.textContent = review.authorName || "";
    const time = document.createElement("p");
    time.className = "google-reviews__author-time";
    time.textContent = review.relativeTimeDescription || "";
    author.appendChild(name);
    author.appendChild(time);
    header.appendChild(author);
    card.appendChild(header);

    const stars = document.createElement("span");
    stars.className = "rating";
    stars.setAttribute("role", "img");
    const starsInner = document.createElement("span");
    applyStars(starsInner, review.rating, 5);
    stars.appendChild(starsInner);
    card.appendChild(stars);

    const text = document.createElement("p");
    text.className = "google-reviews__text";
    text.textContent = review.text || "";
    card.appendChild(text);

    li.appendChild(card);
    return li;
  }

  function initWidget(root) {
    const sectionId = root.dataset.sectionId;
    const proxyBase = root.dataset.proxyBase || "/apps/scheduling";

    const loadingEl = document.getElementById(`GoogleReviewsLoading-${sectionId}`);
    const errorEl = document.getElementById(`GoogleReviewsError-${sectionId}`);
    const contentEl = document.getElementById(`GoogleReviewsContent-${sectionId}`);
    const starsEl = document.getElementById(`GoogleReviewsStars-${sectionId}`);
    const scoreEl = document.getElementById(`GoogleReviewsScore-${sectionId}`);
    const countEl = document.getElementById(`GoogleReviewsCount-${sectionId}`);
    const listEl = document.getElementById(`Slider-GoogleReviews-${sectionId}`);
    const ctaEl = document.getElementById(`GoogleReviewsCta-${sectionId}`);
    const totalEl = root.querySelector(".slider-counter--total");
    const sliderComponentEl = root.querySelector("slider-component");

    fetch(`${proxyBase}/api/reviews`, { headers: { Accept: "application/json" } })
      .then((res) => {
        if (!res.ok) throw new Error(`Reviews request failed (${res.status})`);
        return res.json();
      })
      .then((data) => {
        if (!data || !Array.isArray(data.reviews) || data.reviews.length === 0) {
          throw new Error("No reviews returned");
        }

        if (typeof data.rating === "number") {
          const starsInner = document.createElement("span");
          applyStars(starsInner, data.rating, 5);
          starsEl.appendChild(starsInner);
          scoreEl.textContent = data.rating.toFixed(1);
        }
        if (typeof data.userRatingsTotal === "number") {
          countEl.textContent = `(${data.userRatingsTotal})`;
        }

        data.reviews.forEach((review, index) => {
          listEl.appendChild(buildSlide(review, sectionId, index + 1));
        });
        if (totalEl) totalEl.textContent = String(data.reviews.length);

        if (data.placeUrl) {
          ctaEl.href = data.placeUrl;
          ctaEl.hidden = false;
        }

        loadingEl.hidden = true;
        contentEl.hidden = false;

        if (sliderComponentEl && typeof sliderComponentEl.resetPages === "function") {
          // Slide elements didn't exist when slider-component connected, so
          // its constructor found nothing to page through (sliderItems was
          // captured empty at construction time) — recompute now that the
          // real slides are in the DOM.
          sliderComponentEl.resetPages();
          // Appending 5 slides also changes the observed list's scrollWidth,
          // which fires the component's own ResizeObserver asynchronously.
          // That callback calls initPages() directly (not resetPages()), so
          // it recomputes from the stale empty sliderItems captured at
          // construction and clobbers the correct state set above. A short
          // follow-up call, timed after that callback has had a chance to
          // fire, wins the race and leaves the slider in the right state.
          setTimeout(() => sliderComponentEl.resetPages(), 100);
        }
      })
      .catch(() => {
        loadingEl.hidden = true;
        errorEl.hidden = false;
      });
  }

  document.querySelectorAll(".google-reviews__app").forEach(initWidget);
})();
